module.exports = __webpack_public_path__ + "static/media/2.78e7b9be.png";